import {
  CustomMapHotspots,
  GoogleMapAmea,
  GoogleMapGarbage,
  GoogleMapHydroMeters,
  GoogleMapInfoStand,
  GoogleMapVehicles,
  GoogleMapWifiHotSpot,
} from "./GoogleMapStyles";

import * as Icon from "../Map/smartiscity/Icons";
import { infrastructureCategoryFilters } from "./utils";

export const filterDataSingleValueReturn = (data, directive, returnValue) =>
  data.filter((item) => item[directive]).map((item) => item[returnValue]);

const pathToObject = (item, directives) => {
  let current = item;
  const keys = directives.split(".");
  if (keys.length === 1) {
    return item[directives];
  } else {
    for (let i = 0; i < keys.length; i++) {
      current = current[keys[i]];
    }
    return current;
  }
};

export const filterDataWithMultipleDirectives = (
  data,
  orDirectives, // []
  andDirectives = null,
  orCheckValue, //category
  andCheckValue
) => {
  return data.filter((item) =>
    andDirectives === null
      ? orDirectives.includes(pathToObject(item, orCheckValue))
      : orDirectives.includes(pathToObject(item, orCheckValue)) &&
        andDirectives.includes(pathToObject(item, andCheckValue))
  );
};

export const getMapStyles = (categoryId) => {
  switch (categoryId) {
    case "4":
      return GoogleMapWifiHotSpot;
    case "8":
      return GoogleMapVehicles;
    case "9":
      return GoogleMapGarbage;
    case "10":
      return GoogleMapHydroMeters;
    case "31":
      return GoogleMapInfoStand;
    case "122":
      return GoogleMapAmea;
    default:
      return CustomMapHotspots;
  }
};

export const getMarkerIcon = (markerCategory) => {
  const category = infrastructureCategoryFilters.filter(
    (cat, id) => cat.name === markerCategory
  )[0]?.typeId;

  switch (category) {
    case "1":
      return Icon.dRamp;
    case "3":
      return Icon.dPavement;
    case "5":
      return Icon.dChangingRoom;
    case "6":
      return Icon.dCrossing;
    case "7":
      return Icon.dLights;
    case "8":
      return Icon.dLift;
    case "9":
    default:
      return Icon.dOther;
  }
};

export const formatMapData = (categoryId, item, isInfra) => {
  console.log("TEST: item", item);
  switch (categoryId) {
    case "5":
      return {
        title: item.mysensor_name,
        position: {
          lat: parseFloat(item.lat),
          lng: parseFloat(item.lng),
        },
        icon: Icon.greenMark,
        id: item.mysensor_id,
      };
    case "24":
      return {
        title: item.boxTitle ?? item.mysensor_name ?? item.LabelOnStreet,
        subTitle: item.address ?? item.sensor_address,
        position: {
          lat: item.Lat,
          lng: item.Lon,
        },
        icon: Icon.purpleMark,
        id: item.id,
        isOccupied: item.IsOccupied,
      };
    case "31":
      return {
        title: item.boxTitle ?? item.mysensor_name,
        subTitle: item.address ?? item.sensor_address,
        position: {
          lat: parseFloat(item.lat),
          lng: parseFloat(item.lng),
        },
        icon: Icon.purpleMark,
        id: item.mysensor_id,
      };
    case "122":
      return {
        name: item.category,
        title: isInfra
          ? `${AmeaCategorySingularName(item.category)} ${item.title}`
          : item.title,
        subTitle: isInfra ? `${item.type}ς χρήσης` : item.category,
        position: isInfra
          ? {
              lat: item?.latitude,
              lng: item?.longitude,
            }
          : {
              lat: item?.infrastructures && item?.infrastructures[0].latitude,
              lng: item?.infrastructures && item?.infrastructures[0].longitude,
            },
        icon: getMarkerIcon(item.category),
        id: item.id,
      };
  }
};

export const AmeaCategorySingularName = (name) => {
  switch (name) {
    case "Ράμπες":
      return "Ράμπα";
    case "Πεζοδρόμια ΑΜΕΑ":
      return "Πεζοδρόμιο ΑΜΕΑ";
    case "Αποδητήρια ΑΜΕΑ":
      return "Αποδητήριο ΑΜΕΑ";
    case "Διάβαση τυφλών":
      return "Διάβαση τυφλών";
    case "Φανάρι με ήχο":
      return "Φανάρι με ήχο";
    case "Ανελκυστήρες":
      return "Ανελκυστήρας";
    default:
      return name;
  }
};
